<template>
  <ExpandBarTransition>
    <BaseBar
      v-if="show"
      class="theme-bar bg-white text-secondary col-12 hover-pointer"
      @click.native="$emit('clicked', theme.display_order)"
    >
      <div class="theme-bar__title d-inline-flex items-center">
        <span class="text-secondary pe-2">{{ suffixTitle }}</span>
        <span class="text-secondary">{{ theme.name }}</span>
      </div>
      <div v-show="isThemeComplete" class="theme-bar__complete text-right">
        <FontAwesomeIcon class="fa-2x text-success" :icon="['fas', 'check']" />
      </div>
      <EntityBarProgress
        :current-question-ids="questionIds"
        :sub-title="null"
        class="theme-bar__progress text-secondary"
      />
    </BaseBar>
  </ExpandBarTransition>
</template>

<script>
import BaseBar from '../Components/BaseBar.vue'
import ExpandBarTransition from './Transitions/ExpandBarTransition.vue'
import EntityBarProgress from './EntityBarProgress.vue'

export default {
  components: { BaseBar, ExpandBarTransition, EntityBarProgress },
  props: {
    theme: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    suffixTitle() {
      return `${this.theme.theme_number}`
    },
    isThemeComplete() {
      return this.responsesCount === this.questionIds.length
    },
    responsesCount() {
      const intersect = this.questionIds.filter((x) =>
        this.$page.props.survey.responses
          .map((x) => x.survey_question_id)
          .includes(x)
      )
      return intersect.length
    },
    questionIds() {
      return this.theme.questions.map((x) => x.id)
    },
  },
}
</script>

<style lang="scss">
.theme-bar {
  display: grid;
  grid-template-columns: 80% 5% 15%;
  grid-template-rows: 1fr;
  grid-template-areas: 'title complete progress';
  padding-right: 2.5rem !important;

  &__title {
    grid-area: title;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.121rem;
  }
  &__complete {
    grid-area: complete;
  }
  &__progress {
    grid-area: progress;
  }
}
</style>
